import type { ReactNode } from "react";
import { ResponsiveContainer } from "recharts";

type ChartResponsiveContainerProps = {
  children: ReactNode;
  /** Altura usada só no primeiro paint, antes do ResizeObserver. */
  initialHeightPx?: number;
};

const INITIAL_WIDTH_PX = 400;
const DEFAULT_INITIAL_HEIGHT_PX = 320;

/**
 * Recharts 3 começa com width/height -1 e avisa no console.
 * Este wrapper preenche o pai (100%) e entrega um tamanho inicial positivo.
 */
export const ChartResponsiveContainer = ({
  children,
  initialHeightPx = DEFAULT_INITIAL_HEIGHT_PX,
}: ChartResponsiveContainerProps) => (
  <ResponsiveContainer
    width="100%"
    height="100%"
    minWidth={0}
    initialDimension={{ width: INITIAL_WIDTH_PX, height: initialHeightPx }}
  >
    {children}
  </ResponsiveContainer>
);
